export default __webpack_public_path__ + "static/media/MANAGER_HAS_DUTIES_-_-_SEASONAL_SYSTEM_.4afe6feb.png";